<div class="gmail-signup-error-container">
  <div class="content-card">
    <div class="illustration-wrapper">
      <svg
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7"
          stroke="#334EA5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="3"
          y="5"
          width="18"
          height="14"
          rx="2"
          stroke="#334EA5"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <h1>Organization Account Required</h1>
    <p>
      Please sign in using your Google Workspace account. Personal Gmail
      accounts are not supported.
    </p>
    <button class="primary-btn" (click)="goToLogin()">Go to Login Page</button>
  </div>
</div>
